<div class="row mt-4">
  <div class="col-md-12">
    <h3>{{ app.getText("operations.actionsTitle") }}</h3>
  </div>
</div>
<div class="row mt-2">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header bg-white text-center">
        <ul class="nav nav-tabs card-header-tabs">
          <li class="nav-item">
            <a
              *ngIf="app.permission.operations.seeMatchParts"
              class="nav-link pointer-link"
              role="button"
              [ngClass]="{ active: workType === 'match' }"
              (click)="workType = 'match'"
              >{{ app.getText("operations.matchParts") }}</a
            >
          </li>
          <li class="nav-item">
            <a
              *ngIf="app.permission.operations.seeRequestDetails"
              class="nav-link pointer-link"
              role="button"
              [ngClass]="{ active: workType === 'request-details' }"
              (click)="workType = 'request-details'"
              >{{ app.getText("operations.requestDetails") }}</a
            >
          </li>
          <li class="nav-item">
            <a
              *ngIf="app.permission.operations.seeUpdatesDetails"
              class="nav-link pointer-link"
              role="button"
              [ngClass]="{ active: workType === 'update-details' }"
              (click)="workType = 'update-details'"
              >{{ app.getText("operations.updateDetails") }}</a
            >
          </li>
          <li class="nav-item">
            <a
              *ngIf="app.permission.operations.seeGenerateTree"
              class="nav-link pointer-link"
              role="button"
              [ngClass]="{ active: workType === 'generate-tree' }"
              (click)="workType = 'generate-tree'"
              >{{ app.getText("operations.generateTree") }}</a
            >
          </li>
          <li class="nav-item">
            <a
              *ngIf="app.permission.operations.seeBuildBOM"
              class="nav-link pointer-link"
              role="button"
              [ngClass]="{ active: workType === 'build-bom' }"
              (click)="workType = 'build-bom'"
              >{{ app.getText("operations.buildBOM") }}</a
            >
          </li>
          <li class="nav-item">
            <a
              *ngIf="app.permission.operations.seeUpdatesImpacts"
              class="nav-link pointer-link"
              role="button"
              [ngClass]="{ active: workType === 'update-impacts' }"
              (click)="workType = 'update-impacts'"
              >{{ app.getText("operations.updateImpacts") }}</a
            >
          </li>
          <li class="nav-item">
            <a
              *ngIf="app.permission.operations.seeGenerateAlerts"
              class="nav-link pointer-link"
              role="button"
              [ngClass]="{ active: workType === 'generate-alerts' }"
              (click)="workType = 'generate-alerts'"
              >{{ app.getText("operations.generateAlerts") }}</a
            >
          </li>
          <li class="nav-item">
            <a
              *ngIf="app.permission.operations.seeAuditLogs"
              class="nav-link pointer-link"
              role="button"
              [ngClass]="{ active: isAuditLogsView }"
              (click)="getAuditLogs()"
              >{{ app.getText("operations.seeAuditLogs") }}</a
            >
          </li>
          <li class="nav-item">
            <a
              *ngIf="app.permission.operations.seeAuditLogs"
              class="nav-link pointer-link"
              role="button"
              [ngClass]="{ active: isMigrationHistoryView }"
              (click)="getMigrationHistory()"
              >{{ app.getText("operations.seeMigrationHistory") }}</a
            >
          </li>
        </ul>
      </div>
      <div class="card-body">
        <div class="row">
          <div
            class="col-md-6"
            [ngClass]="{
              'col-md-12':
                isAuditLogsView || isMigrationHistoryView,
              'col-md-8':
                !isAuditLogsView &&
                !isMigrationHistoryView &&
                (workType === 'update-details' ||
                  workType === 'generate-tree' ||
                  workType === 'build-bom' ||
                  workType === 'update-impacts' ||
                  workType === 'generate-alerts'),
            }"
          >
            <div [ngSwitch]="workType">
              <small *ngSwitchCase="'match'" class="text-muted"
                ><i class="fa fa-info-circle"></i>&nbsp;{{
                  app.getText("operations.matchPartsDescription")
                }}</small
              >
              <small *ngSwitchCase="'request-details'" class="text-muted"
                ><i class="fa fa-info-circle"></i>&nbsp;{{
                  app.getText("operations.requestDetailsDescription")
                }}</small
              >
              <small *ngSwitchCase="'update-details'" class="text-muted"
                ><i class="fa fa-info-circle"></i>&nbsp;{{
                  app.getText("operations.updateDetailsDescription")
                }}</small
              >
              <small *ngSwitchCase="'generate-tree'" class="text-muted"
                ><i class="fa fa-info-circle"></i>&nbsp;{{
                  app.getText("operations.generateTreeDescription")
                }}</small
              >
              <small *ngSwitchCase="'build-bom'" class="text-muted"
                ><i class="fa fa-info-circle"></i>&nbsp;{{
                  app.getText("operations.buildBOMDescription")
                }}</small
              >
              <small *ngSwitchCase="'update-impacts'" class="text-muted"
                ><i class="fa fa-info-circle"></i>&nbsp;{{
                  app.getText("operations.updateImpactsDescription")
                }}</small
              >
              <small *ngSwitchCase="'generate-alerts'" class="text-muted"
                ><i class="fa fa-info-circle"></i>&nbsp;{{
                  app.getText("operations.generateAlertsDescription")
                }}</small
              >
              <small *ngSwitchCase="'see-auditLogs'" class="text-muted"
                ><i class="fa fa-info-circle"></i>&nbsp;{{
                  app.getText("operations.auditLogsDescription")
                }}</small
              >
              <small *ngSwitchCase="'see-migrationHistory'" class="text-muted"
                ><i class="fa fa-info-circle"></i>&nbsp;{{
                  app.getText("operations.migrationHistoryDescription")
                }}</small
              >
            </div>
          </div>
          <div
            *ngIf="
              !isAuditLogsView &&
              !isMigrationHistoryView &&
              (workType === 'update-details' ||
                workType === 'generate-tree' ||
                workType === 'build-bom' ||
                workType === 'update-impacts' ||
                workType === 'generate-alerts')
            "
            class="col-md-4 align-self-center"
          >
            <div class="card mt-3 mt-md-0">
              <div
                class="card-body d-flex flex-column"
                [ngClass]="{
                  'align-items-start align-items-md-end':
                    (workType === 'generate-alerts' && app.customer === 'mtu') ||
                    (workType === 'update-impacts' && app.customer === 'db'),
                  'align-items-center justify-content-center':
                    !(workType === 'generate-alerts' && app.customer === 'mtu') &&
                    !(workType === 'update-impacts' && app.customer === 'db'),
                }"
              >
                <div
                  *ngIf="workType === 'generate-alerts' && app.customer === 'mtu'"
                >
                  <div
                    class="d-inline-flex align-items-center gap-2 flex-wrap justify-content-md-end"
                  >
                    <label class="label mb-0">{{
                      app.field.getLabel(app.fieldId.part.standardRange)
                    }}</label>
                    <input
                      class="form-control searchInput"
                      type="number"
                      [(ngModel)]="parameterModel.standardRange"
                    />
                    <button
                      class="btn btn-sm btn-save"
                      (click)="saveStandardRange()"
                      [disabled]="isDisabled(true)"
                    >
                      <i class="fa fa-check"></i>
                      {{ app.text.operations.saveData }}
                    </button>
                  </div>
                </div>
                <div
                  class="mt-2 d-flex flex-wrap"
                  [ngClass]="{
                    'justify-content-md-end':
                      (workType === 'generate-alerts' && app.customer === 'mtu') ||
                      (workType === 'update-impacts' && app.customer === 'db'),
                    'justify-content-center':
                      !(workType === 'generate-alerts' && app.customer === 'mtu') &&
                      !(workType === 'update-impacts' && app.customer === 'db'),
                  }"
                >
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm"
                    (click)="runWork()"
                    [disabled]="loading || isDisabled(false)"
                  >
                    <i
                      class="fa"
                      [ngClass]="{
                        'fa-spinner fa-spin': loading,
                        'fa-play-circle': !loading,
                      }"
                    ></i
                    >&nbsp; {{ app.getText("operations.run") }}
                    {{ app.operations.getTypeText(workType) }}
                  </button>
                  <button
                    *ngIf="workType === 'update-impacts' && app.customer === 'db'"
                    type="button"
                    class="btn btn-outline-primary btn-sm ms-2"
                    (click)="runUpdateTaskResponsibles()"
                    [disabled]="loading"
                  >
                    <i
                      class="fa"
                      [ngClass]="{
                        'fa-spinner fa-spin': loading,
                        'fa-play-circle': !loading,
                      }"
                    ></i
                    >&nbsp; {{ app.getText("operations.run") }}
                    {{ app.text.operations.updateTaskResponsibles }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            *ngIf="
              !isAuditLogsView &&
              !isMigrationHistoryView &&
              workType !== 'update-details' &&
              workType !== 'generate-tree' &&
              workType !== 'build-bom' &&
              workType !== 'update-impacts' &&
              workType !== 'generate-alerts'
            "
            class="col-md-6 align-self-center"
          >
            <div
              class="card"
            >
              <div class="card-body">
                <div class="row">
                  <div
                    *ngIf="
                      count != null &&
                      workType !== 'update-details' &&
                      workType !== 'generate-tree' &&
                      workType !== 'build-bom' &&
                      workType !== 'update-impacts' &&
                      workType !== 'generate-alerts'
                    "
                    class="col-md-4 text-danger text-center align-self-center"
                  >
                    <strong>{{ count.usedCount }}</strong>
                    {{ app.getText("operations.usedCount") }}
                  </div>
                  <div
                    *ngIf="
                      count != null &&
                      workType !== 'update-details' &&
                      workType !== 'generate-tree' &&
                      workType !== 'build-bom' &&
                      workType !== 'update-impacts' &&
                      workType !== 'generate-alerts'
                    "
                    class="col-md-4 text-success text-center align-self-center"
                  >
                    <strong>{{ count.remainingCount }}</strong>
                    {{ app.getText("operations.remainingCount") }}
                  </div>
                  <div
                    class="col-md-4"
                    [ngClass]="{
                      'col-md-12': count == null,
                      'text-center': count != null,
                    }"
                  >
                    <button
                      type="button"
                      class="btn btn-outline-primary btn-sm float-right"
                      (click)="runWork()"
                      [disabled]="loading || isDisabled(false)"
                    >
                      <i
                        class="fa"
                        [ngClass]="{
                          'fa-spinner fa-spin': loading,
                          'fa-play-circle': !loading,
                        }"
                      ></i
                      >&nbsp; {{ app.getText("operations.run") }}
                      {{ app.operations.getTypeText(workType) }}
                    </button>
                  </div>
                  <div
                    class="row"
                    *ngIf="
                      count != null &&
                      workType !== 'update-details' &&
                      workType !== 'generate-tree' &&
                      workType !== 'build-bom' &&
                      workType !== 'update-impacts' &&
                      workType !== 'generate-alerts'
                    "
                  >
                    <div
                      class="col-md-4 text-center align-self-center text-muted info"
                    >
                      {{ app.getText("operations.limitCount") }}
                      <strong>{{ count.limitCount }}</strong>
                    </div>
                    <div
                      class="col-md-4 text-center align-self-center text-muted info"
                    >
                      {{ app.getText("operations.expirationDate") }}
                      <strong>{{ count.expirationDate }}</strong>
                    </div>
                    <div
                      class="col-md-4 text-center align-self-center text-muted info"
                    >
                      {{ app.getText("operations.createDate") }}
                      <strong>{{ count.createDate }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!isAuditLogsView && !isMigrationHistoryView">
    <div class="row mt-4">
      <div class="col-md-12">
        <h3>{{ app.getText("operations.historyTitle") }}</h3>
      </div>
    </div>

    <app-paginator
      *ngIf="showPaginator"
      [length]="history.length"
      [index]="app.paginator.focus"
      (focus)="app.paginator.focus = $event"
    ></app-paginator>

    <div class="table-responsive">
      <table class="table table-striped table-font-size">
        <thead>
          <tr>
            <th
              class="table-header"
              *ngFor="let column of app.operations.getOperationsColumns()"
            >
              <span class="pointer">{{
                app.field.getLabel("operations." + column)
              }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of app.paginator.getPage(history)">
            <td
              class="p-1"
              *ngFor="let column of app.operations.getOperationsColumns()"
            >
              <span
                *ngIf="column === 'create_time' || column === 'complete_time'"
              >
                {{ item[column] | date: "yyyy-MM-dd HH:mm:ss" }}
              </span>
              <span *ngIf="column === 'work_type'">
                {{ app.operations.getTypeText(item[column]) }}
              </span>
              <span *ngIf="column === 'work_log'">
                <button
                  type="button"
                  class="btn btn-link p-0"
                  (click)="downloadLog(item)"
                >
                  <i class="fa fa-file-download"></i>
                </button>
              </span>
              <span *ngIf="!app.operations.isSpecialColumn(column)">
                {{ item[column] }}
              </span>
            </td>
          </tr>
          <tr *ngIf="history.length === 0">
            <td colspan="99" class="p-1 text-center">
              {{ app.getText("operations.noHistoryAvailable") }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
<div class="row">
  <div class="col-md-12 mt-3">
  <div *ngIf="isMigrationHistoryView">
    <div class="row mt-4">
      <div class="col-md-12">
        <h3>{{ app.getText("operations.migrationHistoryTitle") }}</h3>
      </div>
    </div>
    <app-paginator
      *ngIf="showPaginator"
      [length]="app.operations.migrationHistory.length"
      [index]="app.paginator.focus"
      (focus)="app.paginator.focus = $event"
    ></app-paginator>

    <div class="table-responsive">
      <table class="table table-striped table-font-size">
        <thead>
          <tr>
            <th
              class="table-header"
              *ngFor="let column of app.list.operations.migrationColumns"
            >
              <span class="pointer">{{ app.field.getLabel(column) }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let item of app.paginator.getPage(app.operations.migrationHistory)"
            (click)="getMigrationRuns(item)"
            class="pointer"
            [ngClass]="{
              'table-active':
                selectedMigrationHistory &&
                selectedMigrationHistory.migration_id === item.migration_id,
            }"
          >
            <td
              class="p-1"
              *ngFor="let column of app.list.operations.migrationColumns"
            >
              <span
                *ngIf="
                  column === 'operations.last_started_at' ||
                  column === 'operations.last_completed_at'
                "
              >
                {{ item[column.split(".")[1]] | date: "yyyy-MM-dd HH:mm:ss" }}
              </span>
              <span
                *ngIf="
                  column === 'operations.last_status' ||
                  column === 'operations.status'
                "
              >
                {{ app.getText("operations." + item[column.split(".")[1]]) }}
              </span>
              <span
                *ngIf="
                  column === 'operations.last_forced' ||
                  column === 'operations.forced'
                "
              >
                {{ app.getText(item[column.split(".")[1]] ? "app.yes" : "app.no") }}
              </span>
              <span
                *ngIf="
                  column !== 'operations.last_started_at' &&
                  column !== 'operations.last_completed_at' &&
                  column !== 'operations.last_status' &&
                  column !== 'operations.status' &&
                  column !== 'operations.last_forced' &&
                  column !== 'operations.forced'
                "
              >
                {{ item[column.split(".")[1]] }}
              </span>
            </td>
          </tr>
          <tr *ngIf="app.operations.migrationHistory.length === 0">
            <td colspan="99" class="p-1 text-center">
              {{ app.getText("operations.noMigrationHistoryAvailable") }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="selectedMigrationHistory != null">
      <div class="row mt-4">
        <div class="col-md-12">
          <h3>{{ app.getText("operations.migrationRunsTitle") }}</h3>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-striped table-font-size">
          <thead>
            <tr>
              <th
                class="table-header"
                *ngFor="let column of app.list.operations.migrationRunColumns"
              >
                <span class="pointer">{{ app.field.getLabel(column) }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of app.operations.migrationRuns">
              <td
                class="p-1"
                *ngFor="let column of app.list.operations.migrationRunColumns"
              >
                <span
                  *ngIf="
                    column === 'operations.started_at' ||
                    column === 'operations.completed_at'
                  "
                >
                  {{ item[column.split(".")[1]] | date: "yyyy-MM-dd HH:mm:ss" }}
                </span>
                <span
                  *ngIf="column === 'operations.status'"
                >
                  {{ app.getText("operations." + item[column.split(".")[1]]) }}
                </span>
                <span
                  *ngIf="column === 'operations.forced'"
                >
                  {{
                    app.getText(item[column.split(".")[1]] ? "app.yes" : "app.no")
                  }}
                </span>
                <span
                  *ngIf="
                    column !== 'operations.started_at' &&
                    column !== 'operations.completed_at' &&
                    column !== 'operations.status' &&
                    column !== 'operations.forced'
                  "
                >
                  {{ item[column.split(".")[1]] }}
                </span>
              </td>
            </tr>
            <tr *ngIf="app.operations.migrationRuns.length === 0">
              <td colspan="99" class="p-1 text-center">
                {{ app.getText("operations.noMigrationRunsAvailable") }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div *ngIf="isAuditLogsView">
    <!-- *ngIf="showExport" -->
    <div class="row justify-content-end">
      <div class="col-auto">
        <button class="btn btn-sm btn-clean" (click)="exportAuditLogs()">
          <i class="fa fa-download"></i>&nbsp;
          {{ app.text.alert.export }}
        </button>
      </div>
    </div>
    <app-paginator
      [length]="app.operations.auditLogs.length"
      [index]="app.paginator.focus"
      (focus)="app.paginator.focus = $event"
    ></app-paginator>

    <div class="table-responsive">
      <table class="table table-striped table-font-size">
        <thead>
          <tr>
            <th>{{ app.text.operations.userId }}</th>
            <th>{{ app.text.operations.time }}</th>
            <th>{{ app.text.operations.reason }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let item of app.paginator.getPage(app.operations.auditLogs)"
          >
            <td>{{ app.users.getOptionName(item.userId) }}</td>
            <td>{{ item.time | date : "yyyy-MM-dd HH:mm:ss"  }}</td>
            <td>{{ item.content }}</td>
          </tr>
          <tr *ngIf="app.operations.auditLogs.length === 0">
            <td colspan="99" class="p-1 text-center">
              {{ app.getText("operations.noAuditLogsAvailable") }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  </div>

</div>

</div>
